import { Trans } from '@lingui/react/macro';
import { StyledTypography } from './styled';
export function NoSelectableFileMessage() {
    return (<StyledTypography $fontSize="small" $appearance="100">
      <Trans comment="No file to select in the file browser">No files to select</Trans>
    </StyledTypography>);
}
